export interface Manga {
  id: string;
  title: string;
  genre: string;
  genres: string[];
  author: string;
  status: "连载中" | "已完结";
  rating: number;
  chapters: number;
  followers: string;
  views: string;
  cover: string;
  tags: string[];
  desc: string;
  latest: string;
  updateTime: string;
}

export const mangaList: Manga[] = [
  {
    id: "yingluo-zhizheng",
    title: "樱落之城",
    genre: "都市奇幻",
    genres: ["都市", "奇幻", "治愈"],
    author: "时雨",
    status: "连载中",
    rating: 9.6,
    chapters: 128,
    followers: "86.4万",
    views: "3.2亿",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20chinese%20manga%20cover%20illustration%20of%20a%20dreamy%20sakura%20city%20at%20dusk%2C%20young%20protagonist%20silhouette%20standing%20on%20a%20rooftop%20overlooking%20glowing%20neon%20lanterns%20and%20falling%20cherry%20blossoms%2C%20warm%20coral%20and%20soft%20pink%20palette%2C%20clean%20cinematic%20composition%2C%20rich%20detail%2C%20anime%20poster%20style&width=400&height=560&seq=manga-cover-01&orientation=portrait",
    tags: ["高分治愈", "都市奇幻", "连载中"],
    desc: "在樱花飘落的旧城区，少女林眠意外获得窥见城市记忆的能力。她与见习书店店主陆遥一起，用温柔的笔触为那些被遗忘的故事画下句点。",
    latest: "第128话 樱落之时（上）",
    updateTime: "2小时前更新",
  },
  {
    id: "fengqi-shanhai",
    title: "风起山海",
    genre: "热血冒险",
    genres: ["热血", "冒险", "战斗"],
    author: "白鹭",
    status: "连载中",
    rating: 9.4,
    chapters: 96,
    followers: "52.1万",
    views: "1.8亿",
    cover: "https://readdy.ai/api/search-image?query=Epic%20chinese%20manga%20cover%20illustration%20of%20a%20young%20hero%20with%20wind%20sweeping%20through%20his%20robes%20on%20a%20cliff%20above%20ancient%20misty%20mountains%2C%20dramatic%20sky%20with%20golden%20sunlight%20and%20flying%20birds%2C%20warm%20amber%20and%20crimson%20tones%2C%20dynamic%20action%20pose%2C%20cinematic%20epic%20anime%20style%2C%20rich%20texture&width=400&height=560&seq=manga-cover-02&orientation=portrait",
    tags: ["热血冒险", "国漫", "战斗"],
    desc: "少年叶长风手持半卷残图，踏上寻找失落的山海秘境的旅途。一路风雨，一路伙伴，只为兑现十年前对师父许下的承诺。",
    latest: "第96话 山海之门",
    updateTime: "昨天更新",
  },
  {
    id: "shenye-shitang",
    title: "深夜食堂笔记",
    genre: "治愈美食",
    genres: ["美食", "治愈", "日常"],
    author: "暖粥",
    status: "已完结",
    rating: 9.7,
    chapters: 74,
    followers: "73.8万",
    views: "2.6亿",
    cover: "https://readdy.ai/api/search-image?query=Warm%20chinese%20manga%20cover%20of%20a%20cozy%20little%20night%20eatery%20with%20steaming%20bowls%20of%20soup%20and%20warm%20lantern%20light%2C%20a%20kind%20chef%20wiping%20a%20counter%2C%20soft%20golden%20glow%2C%20gentle%20healing%20mood%2C%20warm%20orange%20and%20cream%20palette%2C%20clean%20cozy%20composition%2C%20anime%20slice%20of%20life%20style&width=400&height=560&seq=manga-cover-03&orientation=portrait",
    tags: ["治愈美食", "高分", "已完结"],
    desc: "午夜十二点，城市角落的小食堂准时亮灯。每一道家常菜背后，都藏着一位夜归人说不出口的心事。暖胃，也暖心。",
    latest: "已完结",
    updateTime: "完结",
  },
  {
    id: "xinggui-shaonian",
    title: "星轨少年",
    genre: "科幻冒险",
    genres: ["科幻", "冒险", "成长"],
    author: "灰雀",
    status: "连载中",
    rating: 9.1,
    chapters: 63,
    followers: "41.5万",
    views: "1.2亿",
    cover: "https://readdy.ai/api/search-image?query=Futuristic%20chinese%20manga%20cover%20of%20a%20teenage%20pilot%20in%20a%20spacecraft%20cabin%20gazing%20at%20a%20nebula%20through%20the%20window%2C%20starlit%20galaxy%20background%2C%20warm%20copper%20and%20teal%20accents%20on%20dark%20blue%20space%2C%20cinematic%20depth%2C%20detailed%20anime%20science%20fiction%20artwork%2C%20hopeful%20mood&width=400&height=560&seq=manga-cover-04&orientation=portrait",
    tags: ["科幻", "太空", "成长"],
    desc: "落榜少年闻野被一所神秘航空学院录取。他驾驶老旧的星轨号穿梭星海，在一次次危机中，找到了属于自己的轨道。",
    latest: "第63话 银河灯塔",
    updateTime: "3天前更新",
  },
  {
    id: "zhiyuan-shaonian",
    title: "纸鸢与少年",
    genre: "青春校园",
    genres: ["青春", "校园", "友情"],
    author: "青禾",
    status: "连载中",
    rating: 9.2,
    chapters: 55,
    followers: "38.9万",
    views: "1.1亿",
    cover: "https://readdy.ai/api/search-image?query=Light%20chinese%20manga%20cover%20of%20two%20high%20school%20friends%20flying%20a%20colorful%20paper%20kite%20on%20a%20green%20hill%20under%20a%20clear%20sky%2C%20school%20uniforms%2C%20fresh%20spring%20breeze%2C%20warm%20sunlight%20and%20soft%20green%20trees%2C%20gentle%20youthful%20nostalgia%2C%20clean%20composition%2C%20bright%20anime%20style&width=400&height=560&seq=manga-cover-05&orientation=portrait",
    tags: ["青春", "友情", "治愈"],
    desc: "转学而来的少年阿夏，用一只只亲手扎的纸鸢，串起了小镇少年们的夏天与秘密。有些约定，飞得再高也记得回家。",
    latest: "第55话 风筝线那端",
    updateTime: "5天前更新",
  },
  {
    id: "gujuan-qitan",
    title: "古卷奇谭",
    genre: "国风志怪",
    genres: ["国风", "志怪", "悬疑"],
    author: "墨渊",
    status: "连载中",
    rating: 9.3,
    chapters: 82,
    followers: "47.2万",
    views: "1.5亿",
    cover: "https://readdy.ai/api/search-image?query=Traditional%20chinese%20manga%20cover%20of%20a%20scholar%20with%20an%20ancient%20scroll%20surrounded%20by%20mystical%20fox%20spirits%20and%20paper%20lanterns%20in%20an%20ink%20painting%20style%2C%20warm%20vermilion%20and%20gold%20accents%2C%20misty%20ancient%20temple%20background%2C%20elegant%20brushwork%2C%20Chinese%20ink%20wash%20aesthetic%2C%20mysterious%20atmosphere&width=400&height=560&seq=manga-cover-06&orientation=portrait",
    tags: ["国风", "志怪", "水墨"],
    desc: "落魄书生白止因一卷残破古卷，卷入百妖横行的旧都。以笔为刃，以卷为界，他在妖与人之间写下新的传说。",
    latest: "第82话 灯下问妖",
    updateTime: "4天前更新",
  },
  {
    id: "tangxin-qiyue",
    title: "糖心契约",
    genre: "恋爱治愈",
    genres: ["恋爱", "治愈", "轻松"],
    author: "奶糖",
    status: "连载中",
    rating: 8.9,
    chapters: 68,
    followers: "56.7万",
    views: "2.0亿",
    cover: "https://readdy.ai/api/search-image?query=Cute%20chinese%20manga%20cover%20of%20a%20shy%20girl%20and%20a%20baker%20boy%20holding%20a%20pink%20strawberry%20cake%20in%20a%20sunny%20bakery%2C%20sakura%20and%20cream%20color%20palette%2C%20sparkling%20eyes%2C%20soft%20romantic%20light%2C%20clean%20sweet%20composition%2C%20cute%20anime%20romance%20style%2C%20delicate%20details&width=400&height=560&seq=manga-cover-07&orientation=portrait",
    tags: ["恋爱", "治愈", "轻松"],
    desc: "因为一份奇怪的「糖心契约」，甜品学徒夏至和面点师顾言被迫搭档经营街角小店。从互不顺眼到心跳加速，甜度一路加满。",
    latest: "第68话 限定甜点",
    updateTime: "1天前更新",
  },
  {
    id: "wuyin-zhentanshe",
    title: "雾隐侦探社",
    genre: "推理悬疑",
    genres: ["推理", "悬疑", "烧脑"],
    author: "陈墨",
    status: "连载中",
    rating: 9.0,
    chapters: 47,
    followers: "29.8万",
    views: "8600万",
    cover: "https://readdy.ai/api/search-image?query=Mysterious%20chinese%20manga%20cover%20of%20a%20detective%20with%20a%20trench%20coat%20and%20magnifying%20glass%20in%20a%20rainy%20foggy%20laneway%20with%20neon%20signs%2C%20dramatic%20low%20key%20lighting%2C%20warm%20amber%20and%20dark%20umber%20tones%2C%20suspenseful%20moody%20atmosphere%2C%20cinematic%20anime%20thriller%20style%2C%20high%20contrast&width=400&height=560&seq=manga-cover-08&orientation=portrait",
    tags: ["推理", "烧脑", "悬疑"],
    desc: "雾城每一桩离奇案件的背后，都有一道普通人看不见的影子。雾隐侦探社只接无解之案，而真相，往往藏在你从未留意的地方。",
    latest: "第47话 雨夜棋局",
    updateTime: "6天前更新",
  },
  {
    id: "xiayin-lu",
    title: "侠隐录",
    genre: "武侠江湖",
    genres: ["武侠", "江湖", "古风"],
    author: "孤舟",
    status: "已完结",
    rating: 9.5,
    chapters: 210,
    followers: "64.3万",
    views: "2.8亿",
    cover: "https://readdy.ai/api/search-image?query=Martial%20arts%20chinese%20manga%20cover%20of%20a%20swordsman%20in%20flowing%20robes%20standing%20under%20a%20sakura%20tree%20with%20a%20sword%20in%20hand%2C%20ink%20and%20wash%20background%20with%20distant%20mountains%2C%20warm%20vermilion%20and%20gold%20palette%2C%20elegant%20wuxia%20aesthetic%2C%20dynamic%20yet%20graceful%20pose%2C%20detailed%20brushwork&width=400&height=560&seq=manga-cover-09&orientation=portrait",
    tags: ["武侠", "江湖", "古风"],
    desc: "剑客沈九重归隐小镇，本想过平凡日子，却因一桩旧案重入江湖。十年恩怨，一剑了之。快意恩仇，尽在此卷。",
    latest: "已完结",
    updateTime: "完结",
  },
  {
    id: "dijiu-chongzou",
    title: "第九重奏",
    genre: "音乐励志",
    genres: ["音乐", "励志", "青春"],
    author: "弦月",
    status: "连载中",
    rating: 8.8,
    chapters: 39,
    followers: "22.6万",
    views: "6900万",
    cover: "https://readdy.ai/api/search-image?query=Inspiring%20chinese%20manga%20cover%20of%20a%20young%20musician%20playing%20the%20piano%20in%20a%20warmly%20lit%20concert%20hall%2C%20music%20notes%20floating%20in%20the%20air%2C%20golden%20stage%20light%2C%20warm%20honey%20and%20cream%20palette%2C%20emotional%20uplifting%20mood%2C%20cinematic%20composition%2C%20detailed%20anime%20style&width=400&height=560&seq=manga-cover-10&orientation=portrait",
    tags: ["音乐", "励志", "青春"],
    desc: "曾获金奖的少年钢琴手苏澈因一场意外失声失聪。在一次次跌倒中，他重新学会倾听自己内心的旋律。",
    latest: "第39话 无声的前奏",
    updateTime: "1周前更新",
  },
];

export const genreList: string[] = [
  "热血冒险",
  "都市奇幻",
  "治愈美食",
  "青春校园",
  "国风志怪",
  "科幻冒险",
  "恋爱治愈",
  "推理悬疑",
  "武侠江湖",
  "音乐励志",
];